import React from 'react';
import { BookButtonProps } from '../shared/types';
import { IonButton, IonIcon } from '@ionic/react';
import { personAddOutline as waitingListIcon, sendOutline as sendIcon } from 'ionicons/icons';

function GuestAppBookButton(props: BookButtonProps) {
  const { isDisabled, isTimeSlotEnabled, willBePutOnWaitingList, handleSubmit, bookBtnContent } =
    props;
  return (
    <div className="sticky bottom-4 mt-4">
      <IonButton
        color={'primary'}
        expand="block"
        fill="solid"
        shape="round"
        onClick={() => {
          handleSubmit();
        }}
        disabled={isDisabled}
      >
        {bookBtnContent}
        <IonIcon
          slot="end"
          icon={
            !isTimeSlotEnabled ? (willBePutOnWaitingList ? waitingListIcon : sendIcon) : sendIcon
          }
        />
      </IonButton>
    </div>
  );
}

export default GuestAppBookButton;
